import i18n from 'i18next';
import translations_fr from "./locales/fr.json";
import translations_en from "./locales/en.json";
 
i18n.init({
    resources: {
      en: {
        translations: translations_en
      },
      fr: {
        translations: translations_fr
      }
    },
    lng: 'en',
    fallbackLng: 'en',
    debug: false,
 
    // have a common namespace used around the full app
    ns: ['translations'],
    defaultNS: 'translations',
 
    nsSeparator: ".",
    keySeparator: ".", // we use content as keys
 
    interpolation: {
      escapeValue: false
    },
 
    react: {
      wait: false
    }
  });
 
export default i18n;


// WEBPACK FOOTER //
// ./src/translations/i18n.js